"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Dialog = function Dialog(props) {
  var title = props.title,
      children = props.children,
      onClose = props.onClose;

  var ref = /*#__PURE__*/_react.default.createRef();

  (0, _react.useEffect)(function () {
    var clickHandler = function clickHandler(e) {
      var _ref$current;

      if (!((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target))) {
        onClose();
      }
    };

    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [ref, onClose]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'dialog-backdrop'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'dialog-box',
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'dialog-title-bar'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'dialog-title'
  }, title), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fal', 'times'],
    onClick: onClose
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'dialog-body'
  }, children)));
};

Dialog.propTypes = {
  title: _propTypes.default.string,
  children: _propTypes.default.element.isRequired,
  onClose: _propTypes.default.func.isRequired
};
var _default = Dialog;
exports.default = _default;